import{e as r,g as t,m as e}from"./chunk-HBP5N4FR.js";var s={};t(s,{css:()=>o,default:()=>p});var o,p,n=r(()=>{e();o=`.dapp-core-component__progressStyles__progress {
  position: relative;
}
.dapp-core-component__progressStyles__progress .dapp-core-component__progressStyles__bar {
  position: absolute;
  pointer-events: none;
  left: -0.5rem;
  right: -0.5rem;
  bottom: -0.5rem;
  top: -0.5rem;
  background-color: #495057;
  opacity: 0.25;
  transition: width 0.6s ease;
  max-width: calc(100% + 1rem);
}`;document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(o));p={progress:"dapp-core-component__progressStyles__progress",bar:"dapp-core-component__progressStyles__bar"}});export{o as a,p as b,s as c,n as d};
//# sourceMappingURL=chunk-CHQCSVV7.js.map
